import {useNavigate, useSearchParams} from "react-router-dom";
import {useState} from "react";
import Status from "../components/status";
import successIcon from "../icons/success.svg"

export default () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const [orderId] = useState(searchParams.get("orderId"))
    return <div className={"page"} style={{maxHeight:"calc(100vh -32px)"}}>
        <Status
            icon={successIcon}
            title={"Поездка успешно оплачена"}
            button={"К билету"}
            buttonClick={()=>navigate("/order?orderId=" + orderId + "&back=main")}
            subtitle={"Свой билет Вы также можете найти в профиле 2ГИС и вкладке «Проезд»"}/>
    </div>
}